import { generateMessageNo } from './messageNo';
import { postMessage, addListenMessage } from './message';
import { debounce } from './util';
import { getUrlParam } from './url';


let ready = false;
const sessionTraceKey = 'ElkSessionTraceId';
let traceid = ''; //页面traceid
let sessionTraceid = ''; //会话级，可跨域
let noSessionTraceId = false; //不需要sessionTraceId，不需要加载iframe, 有些地方需要禁止加载iframe，比如小程序

const noSessionTraceIdTransferTag = 'noSessionTraceIdTransferTag';

function _isNeedSessionTraceId() {
  //临时补丁，兼容老的noAdtagTransfer
  return +getUrlParam(noSessionTraceIdTransferTag) !== 1 && +getUrlParam("noAdtagTransfer") !== 1 && !noSessionTraceId && !(/app_7_88/.test(location.href));
}

export function setNoSessionTraceId(){
  noSessionTraceId = true
}


/**
 * 存储sessionTraceid
 *
 * @param {string} val
 */
function saveSessionTraceid(val) {
  if (!val) {
    val = generateMessageNo(); //拿不到sessionTraceid，自己生成一个
    registerSessionTraceid(val); //通知iframe，生成了一个，辛苦你保存一下
  }
  sessionStorage.setItem(sessionTraceKey, val);
  setSessionTraceid(val);
}

/**
 * 通知iframe存储sessionTraceid
 *
 * @param {string} val
 */
function registerSessionTraceid(val) {
  postMessage({
    type: 'register_session_traceid',
    sessionTraceid: val
  });
}

function setSessionTraceid(val) {
  sessionTraceid = val;
  ready = true;
}

function postGetMessage() {
  postMessage({
    type: 'get_session_traceid'
  });
}

function listenSetMessage() {
  addListenMessage().then((eData) => {
    const type = eData.type;
    if (type === 'set_session_traceid') saveSessionTraceid(eData.sessionTraceid || ''); //iframe说：这是sessionTraceid，拿去，不谢！
  });
}

function init() {
  // 小程序会禁止加载iframe，这里是为了兼容小程序
  if(!_isNeedSessionTraceId()){
    return true;
  }
  let val = sessionStorage.getItem(sessionTraceKey); //先从sessionStorage获取sessionTraceid
  if (val) {
    setSessionTraceid(val);
  } else {
    postGetMessage();  //若没有sessionTraceid，则跟iframe说：我要拿sessionTraceid 啦
    listenSetMessage(); //监听iframe的消息
  }
}

window.addEventListener('load', () => {
  console.log('window.load 开始 session_traceid 通讯');
  init();
});

export function getTraceid() {
  let val = traceid;
  if (!val) {
    val = traceid = generateMessageNo();
  }
  return val;
}

export function getSessionTraceid() {
  return sessionTraceid;
}

let sessionTraceidPromise
export function checkTraceidReady() {
  if(!_isNeedSessionTraceId()){
    return Promise.resolve(true);
  }
  if (!sessionTraceidPromise) {
    sessionTraceidPromise = new Promise((res, rej) => {
      debounce(() => ready, 0, 15, res, res); //注意，这里失败情况，也resolve出去
    });
  }
  return sessionTraceidPromise;
} 
